<div class="details-container">
  <h3 class="section-title">
    <i class="pi pi-info-circle mr-2"></i>
    Détails de l'intervention
  </h3>

  <!-- Address section -->
  <div class="address-section mb-4">
    <h4 class="subsection-title">
      <i class="pi pi-map-marker mr-2"></i>
      Adresse du chantier
    </h4>

    <div class="address-content">
      {{ addressFormatted }}
    </div>
  </div>

  <!-- Time slot information if applicable -->
  <div *ngIf="hasTimeSlot" class="time-slot-section mb-4">
    <h4 class="subsection-title">
      <i class="pi pi-clock mr-2"></i>
      Créneau horaire
    </h4>

    <div class="time-slot-content">
      {{ timeSlotFormatted }}
    </div>
  </div>

  <!-- Additional flags -->
  <div class="flags-section mb-4">
    <div class="flags-grid">
      <div
        class="flag-item"
        [class.active]="intervention.isDeliveredHouse === 1"
      >
        <i
          class="pi"
          [ngClass]="
            intervention.isDeliveredHouse === 1
              ? 'pi-check-circle text-green-500'
              : 'pi-times-circle text-gray-400'
          "
        ></i>
        <span>Maison livrée</span>
      </div>
      <div
        class="flag-item"
        [class.active]="intervention.isDeliveredHouse === 1"
      >
        <i
          class="pi"
          [ngClass]="
            intervention.doNotShift === 1
              ? 'pi-check-circle text-green-500'
              : 'pi-times-circle text-gray-400'
          "
        ></i>
        <span>Ne pas décaler</span>
      </div>

      <div class="flag-item" [class.active]="intervention.isWaitingCheck === 1">
        <i
          class="pi"
          [ngClass]="
            intervention.isWaitingCheck === 1
              ? 'pi-check-circle text-green-500'
              : 'pi-times-circle text-gray-400'
          "
        ></i>
        <span>En attente réglement</span>
      </div>

      <div class="flag-item" [class.active]="intervention.recoverCheck === 1">
        <i
          class="pi"
          [ngClass]="
            intervention.recoverCheck === 1
              ? 'pi-check-circle text-green-500'
              : 'pi-times-circle text-gray-400'
          "
        ></i>
        <span>Chèque à recupérer</span>
      </div>

      <div class="flag-item" [class.active]="intervention.reportsSent === 1">
        <i
          class="pi"
          [ngClass]="
            intervention.reportsSent === 1
              ? 'pi-check-circle text-green-500'
              : 'pi-times-circle text-gray-400'
          "
        ></i>
        <span>Rapports envoyés</span>
      </div>
    </div>
  </div>

  <!-- Description section -->
  <div class="description-section">
    <h4 class="subsection-title">
      <i class="pi pi-align-left mr-2"></i>
      Description
    </h4>

    <div class="description-content">
      <div *ngIf="intervention.description" class="description-text">
        {{ intervention.description }}
      </div>

      <div
        *ngIf="!intervention.description && intervention.generatedDescription"
        class="description-text"
      >
        <h5 class="generated-title">Description générée</h5>
        <p class="whitespace-pre-line">
          {{ intervention.generatedDescription }}
        </p>
      </div>

      <div
        *ngIf="!intervention.description && !intervention.generatedDescription"
        class="empty-message"
      >
        Aucune description disponible
      </div>
    </div>
  </div>
</div>
